import { ValueGetterParams } from "ag-grid-community";
import { BULK_IDENTIFIER } from "components/product-collection/product-collection-views/product-collection-grid-view/detail-list/helpers";
import { get } from "lodash";

export const CDP_TOTAL_UNITS = ({ getterParams }) => {
    const { api, column }: ValueGetterParams = getterParams;
    let colTotal = 0;
    let bulkTotal = 0;

    let isGroup = false;
    api.forEachNodeAfterFilterAndSort((rowNode) => {
        // If row group is applied, take the value from the group to avoid recalculation at row level
        if (rowNode.group && !isGroup) {
            isGroup = true;
        }

        if (isGroup && !rowNode.group) {
            return;
        } else if (!isGroup && rowNode.group) {
            return;
        }

        const val = api.getValue(column, rowNode) ?? 0;
        const dataType = get(rowNode, "data.type");
        if (dataType === BULK_IDENTIFIER) {
            bulkTotal = +val;
            return;
        }

        colTotal += +val;
    });

    return `${colTotal} / ${bulkTotal}`;
};
